module.exports = __webpack_public_path__ + "static/media/sg-background.24d58d5c.png";